import styles from "./index.module.scss"
import { useRouter } from "next/router"
import { useLocalStorage } from "react-use"
import routes from "../../../../routes"

type Props = {
  redirectUrl: string
  text: string
  onClickClose: () => void
}

export const SimpleLoginDialog: React.FC<Props> = ({
  redirectUrl,
  text,
  onClickClose,
}) => {
  const router = useRouter()
  const [, setRedirectPage] = useLocalStorage<string>("redirect_page", "")

  const signUp = () => {
    setRedirectPage(redirectUrl)
    router.push(routes.authSignUp())
  }

  const signIn = () => {
    setRedirectPage(redirectUrl)
    router.push(routes.authSignIn())
  }

  return (
    <>
      <div className={styles.DialogWrapper}>
        <div className={styles.Dialog}>
          <button className={styles.Dialog_close} onClick={onClickClose}>
            <i className={styles.Dialog_close_icon} title={"閉じる"}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 2L50 50"
                  stroke="white"
                  strokeWidth="5"
                  strokeLinecap="round"
                />
                <path
                  d="M50 2L2 50"
                  stroke="white"
                  strokeWidth="5"
                  strokeLinecap="round"
                />
              </svg>
            </i>
          </button>
          <p className={styles.Dialog_text}>{text}</p>
          <div className={styles.Dialog_buttons}>
            <div className={styles.Dialog_buttons_item}>
              <button onClick={signUp} className={styles.Button}>
                新規登録
              </button>
            </div>
            <div className={styles.Dialog_buttons_item}>
              <p className={styles.Dialog_buttons_item_text}>
                会員登録がお済みの方
              </p>
              <button
                onClick={signIn}
                className={`${styles.Button} ${styles["--login"]}`}
              >
                ログイン
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
